import { flightstatsNextAppHost } from './host-utils';

export const getFSHost = () => flightstatsNextAppHost();



// WEBPACK FOOTER //
// ./src/lib/hostname.js